export const siteClasses = {
  fs_tc: 'tc',
  fs_bcf: 'bcf',
  fs_dyno: 'dyno',
};
